/**
 * Removes any routes that are not intended for the sidebar.
 *
 * @param routes all the routes in the project
 * @returns a list of SidebarRouteConfig (only two levels deep)
 */
export const keepOnlySidebarRoutes = (routes) => routes
    .filter((r) => r.usage === 'sidebar')
    .map((r) => ({
    ...r,
    ...(r.routes?.length && { routes: keepOnlySidebarRoutes(r.routes) }),
}));
